import { render, staticRenderFns } from "./FormSaveCloseBtn.vue?vue&type=template&id=e51a3004"
import script from "./FormSaveCloseBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSaveCloseBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports